import { LayoutItemProps } from "apis";
import { lazy } from "react";

export const PageAdminLayout = lazy(() => import("./List"));
export const PageAdminLayoutCreate = lazy(() => import("./Add"));
export const PageAdminLayoutUpdate = lazy(() => import("./Edit"));

export interface FormLayoutValuesProps extends LayoutItemProps { }

export const validateRenderTags = (htmlString: string) => {
    // DOMParser không parse template {{{template.xxx}}}, nên tạm bỏ chúng ra
    const cleaned = htmlString.replace(/\{\{\{.*?\}\}\}/g, '');
    const parser = new DOMParser();
    const doc = parser.parseFromString(cleaned, 'text/html');

    const renders = Array.from(doc.querySelectorAll('render'));
    const errors: string[] = [];
    const ids = new Set();

    renders.forEach((el, index) => {
        const id = el.getAttribute('data-id');
        if (!id) {
            errors.push(`Thẻ <render> thứ ${index + 1} thiếu data-id.`);
        } else if (ids.has(id)) {
            errors.push(`Thẻ <render> thứ ${index + 1} có data-id trùng: ${id}`);
        } else {
            ids.add(id);
        }
    });

    return errors.length ? errors : undefined;
}